/**
 * CSV for Excel and the accountant. RFC 4180 quoting, CRLF line ends, and a UTF-8 BOM so Excel
 * opens accents and "R" amounts correctly. Pure: the caller decides how to save or share it.
 */

export interface Column<Row> {
  readonly header: string;
  readonly value: (row: Row) => string | number | null | undefined;
}

function cell(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return "";
  const text = String(value);
  return /[",\r\n]/.test(text) || /^\s|\s$/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export function toCsv<Row>(columns: readonly Column<Row>[], rows: readonly Row[]): string {
  const lines = [columns.map((c) => cell(c.header)).join(","), ...rows.map((r) => columns.map((c) => cell(c.value(r))).join(","))];
  return `﻿${lines.join("\r\n")}\r\n`;
}

/** Whole cents → "450.00" (a plain number Excel can sum; the column header says it's rand). */
export function rands(cents: number | undefined): string {
  return cents === undefined ? "" : (cents / 100).toFixed(2);
}

/** "Bella Fiori assets 2026-27.csv": safe for every OS. */
export function exportFileName(...parts: string[]): string {
  return `${parts.join(" ").replace(/[\\/:*?"<>|]+/g, "-").replace(/\s+/g, " ").trim()}.csv`;
}
